export default "__VITE_ASSET__f99c9caa__"